import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=d0dd343a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=d0dd343a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dd343a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0dd343a')) {
      api.createRecord('d0dd343a', component.options)
    } else {
      api.reload('d0dd343a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=d0dd343a&scoped=true&", function () {
      api.rerender('d0dd343a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PlzoaxnL8fxk/JS/comp/Paginate.vue"
export default component.exports